<template>
  <div class="container">
    <breadcrumb v-if="!isMobile" crumb="user-organizations-list" />
    <section v-if="!isMobile" class="driver_section_filter">
      <el-row>
        <el-col :span="12">
          <search-input
            placeholder="Поиск по названию и ИНН органицации"
            @clear="clearFilter"
            @search="handeSearch"
            @input="onInput"
          />
        </el-col>
        <el-col :span="12" class="top-section-right">
          <div v-show="false" class="center" style="justify-content: flex-end">
            <p @click="$router.push({ path: '/driver/add' })">
              Добавить водителя
            </p>
          </div>
          <approve-filters
            :loading="loading"
            :statistics="approvStatistics"
            :status="status"
            @setStatus="setStatus"
          />
        </el-col>
      </el-row>
      <p class="select-all-d">
        <el-checkbox
          v-if="filteredUserOrganizationsList.length && !loading"
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          Выбрать все
        </el-checkbox>
      </p>
    </section>
    <section
      v-if="isMobile"
      class="top-section top-section_driver"
      style="padding-top: 10px"
    >
      <el-button
        type="primary"
        style="width: 100% !important"
        @click="$router.push({ path: '/driver/add' })"
      >
        Добавить водителя
      </el-button>
    </section>
    <el-table
      v-if="loading || !filteredUserOrganizationsList.length"
      v-loading="loading"
      :data="filteredUserOrganizationsList"
      style="width: 100%; height: 40vh; margin-top: 40px"
    />
    <section
      v-if="filteredUserOrganizationsList.length && !loading"
      class="middle-section middle-section_driver"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-checkbox-group
            v-model="checkedUserOrganizations"
            @change="handleCheckedCitiesChange"
          >
            <transition-group name="slide-fade" tag="div">
              <div
                v-for="d in filteredUserOrganizationsList"
                :key="d.id"
                class="check-list"
              >
                <el-row :gutter="24" type="flex" align="middle">
                  <el-col v-if="!isMobile" class="auto-list_col" :span="1">
                    <div class="check-list-time auto-list_col_centered">
                      <el-checkbox :label="d" :value="d" />
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="3">
                    <div class="check-list-person auto-list_col_centered">
                      <div>
                        <p v-if="d.created_at" class="date">
                          {{ dateToFormat(d.created_at) | wordDate }}
                        </p>
                        <p v-else class="date">не указано</p>
                        <p class="date" style="padding-top: 5px">
                          {{ dateToFormat(d.created_at) | sliceDate }}
                        </p>
                      </div>
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="5">
                    <div class="check-list-person auto-list_col_centered">
                      <p>{{ d.organization.short_name }}</p>
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="3">
                    <div class="check-list-person grey auto-list_col_centered">
                      <p>{{ d.organization.inn }}</p>
                      <p>{{ d.bik }}</p>
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="3">
                    <div class="check-list-person grey auto-list_col_centered">
                      <p>{{ d.user ? `+${d.user.login}` : 'не указано' }}</p>
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="7">
                    <div class="check-list-person grey auto-list_col_centered">
                      <p>
                        {{ d.user ? d.user.fio || 'не указано' : 'не указано' }}
                      </p>
                      <p>
                        {{
                          d.user
                            ? d.user.passport || 'не указано'
                            : 'не указано'
                        }}
                      </p>
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="2">
                    <div class="check-list-person grey auto-list_col_centered">
                      <div>
                        <span style="padding-right: 15px">
                          <img
                            src="@/assets/img/truck.svg"
                            alt="truck"
                            width="32"
                            @click="toAuto(d)"
                          />
                        </span>
                        <img
                          src="@/assets/img/user.svg"
                          alt="user"
                          width="32"
                          @click="toDriver(d)"
                        />
                      </div>
                    </div>
                  </el-col>

                  <el-col v-if="!isMobile" class="auto-list_col" :span="1">
                    <div class="check-list-person auto-list_col_centered">
                      <p>
                        <accreditation-lists-icon :approve-data="d" />
                      </p>
                    </div>
                  </el-col>

                  <el-col class="auto-list_col double_button" :xs="4" :sm="2">
                    <div class="check-list-action">
                      <p>
                        <el-button
                          type="success"
                          icon="el-icon-edit"
                          class="no-events"
                          circle
                          @click="infoUserOrganization(d, $event, 1)"
                        />
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </transition-group>
          </el-checkbox-group>
        </el-col>
      </el-row>
    </section>

    <section
      v-if="!isMobile && filteredUserOrganizationsList.length && !loading"
      class="bottom-section"
    >
      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
      <div class="bottom-section-action">
        <p>Выбрано {{ checkedUserOrganizations.length }} организаций</p>
        <el-col class="auto-list_col" :span="4">
          <el-button
            style="background: #e9e9e9; color: #778ca2; border-radius: 4px"
            class="text-block"
            @click="sendApprove(2)"
          >
            ОТКАЗАТЬ
          </el-button>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <el-button
            style="background: #e9e9e9; color: #778ca2; border-radius: 4px"
            class="text-block"
            @click="sendApprove(1)"
          >
            УТВЕРДИТЬ
          </el-button>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <el-button
            type="info"
            plain
            :disabled="!checkedUserOrganizations.length"
            @click="beforeDelete()"
          >
            <p>Удалить</p>
          </el-button>
        </el-col>
      </div>
    </section>
    <passport-user-organization
      :id="showPassportId"
      :dialog-visible="dialogVisible"
      :close-modal="closeModal"
      @create="onCreateOrg"
    />
    <el-dialog
      title="Редактирование контрагента"
      :visible.sync="dialog_edit_contr"
      width="60%"
      center
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <contragent-edit :contragent="edit_contr" />
    </el-dialog>
  </div>
</template>

<script>
import {
  GET_USER_ORGANIZATIONS,
  GET_USER_ORGANIZATIONS_STATS,
} from '@/store/actions/userOrganizations'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { getFilterStatus } from '@/helpers/functions'
import { mapGetters, mapState } from 'vuex'
import AccreditationListsIcon from '@/components/Accreditation/AccreditationListsIcon'
import ApproveFilters from '@/components/Shared/ApproveFilters'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import ContragentEdit from '@/components/Contragents/ContragentEdit'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import PassportUserOrganization from '@/components/Forms/PassportUserOrganization'
import SearchInput from '@/components/Shared/SearchInput'

const Approvements = RepositoryFactory.get('approvements')

export default {
  name: 'UserOrganizationsList',
  components: {
    ContragentEdit,
    PassportUserOrganization,
    PaginationCustom,
    Breadcrumb,
    ApproveFilters,
    SearchInput,
    AccreditationListsIcon,
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checkedUserOrganizations: [],
      curPage: 1,
      rate_user: 3,
      rate_color: ['#3498DB', '#3498DB', '#3498DB'],
      dialogVisible: false,
      dialog_edit_contr: false,
      edit_contr: {},
      editDriver: {},
      status: '',
      search_input: '',
      showPassportId: 0,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'userOrganizations/getLoading',
      userOrganizationsList: 'userOrganizations/getUserOrganizations',
      pagination: 'userOrganizations/getPagination',
    }),
    ...mapState('userOrganizations', ['approvStatistics']),
    filteredUserOrganizationsList() {
      return this.userOrganizationsList
    },
  },
  watch: {
    status: {
      handler: 'getUserOrganizationsList',
      immediate: true,
    },
  },
  mounted() {
    this.loadPage()
  },
  methods: {
    async loadPage() {
      this.checkStatusFilter()
      await this.$store.dispatch(
        `userOrganizations/${GET_USER_ORGANIZATIONS_STATS}`,
      )
    },

    toDriver(user_org) {
      this.$router.push({
        path: '/driver/list?fio=' + user_org.user.fio,
      })
    },
    toAuto(user_org) {
      this.$router.push({
        path: '/auto/list?inn=' + user_org.organization.inn,
      })
    },
    infoUserOrganization(org) {
      this.showPassportId = org.id
      this.dialogVisible = true
    },
    onInput(cur) {
      this.search_input = cur
    },
    setStatus(status) {
      this.status = status || ''
    },
    checkStatusFilter() {
      const query = this.$route.query

      if (query.status && query.status === '0') {
        this.status = query.status
      }
    },
    getUserOrganizationsList() {
      window.scrollTo({ top: 0, left: 0 })
      const status = getFilterStatus(this.status)
      const filterValue = String(this.search_input).trim()
      const org_name = filterValue && filterValue.length > 2 ? filterValue : ''

      this.$store.dispatch(`userOrganizations/${GET_USER_ORGANIZATIONS}`, {
        page: this.curPage,
        status,
        org_name,
      })
    },
    changePage(page) {
      this.curPage = page
      this.getUserOrganizationsList()
    },
    handeSearch() {
      if (!this.search_input) {
        return
      }
      const filterValue = String(this.search_input).trim()

      if (filterValue.length > 2) {
        this.curPage = 1
        this.getUserOrganizationsList()
      }
    },
    clearFilter() {
      this.search_input = ''
      this.curPage = 1
      this.getUserOrganizationsList()
    },
    handleCheckAllChange(val) {
      this.checkedUserOrganizations = val ? this.userOrganizationsList : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length

      this.checkAll = checkedCount === this.userOrganizationsList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.userOrganizationsList.length
    },

    closeModal() {
      this.dialogVisible = false
    },
    onCreateOrg(contr) {
      this.closeModal()

      if (contr) {
        this.$store.dispatch('fetchContragents')
        this.edit_contr = contr
        this.dialog_edit_contr = true
        this.$alert('Контрагент создан проверьте данные')
      }
    },
    closeDialog() {
      this.edit_contr = {}
    },
    sendApprove(newStatus) {
      this.checkedUserOrganizations.map(driver => {
        Approvements.postApprovements({
          link_by_rel: 'drivers',
          link_by_id: driver.id,
          status: newStatus,
          user_org_inn: Number(this.cur_org_inn),
        }).then(() => this.getDriverList())
      })
    },
  },
}
</script>

<style lang="sass">
.el-message-box.before-del
    width: 90%
.no-events
    i
        pointer-events: none
.driver_section_filter
    padding: 0 15px
    .top-section-left
        position: relative
        .search-input
            margin: 30px 0 15px 0
    .select-all-d
        margin: 0
        &:hover
            cursor: pointer
            text-decoration: underline
            .el-checkbox__label
                color: #3498DB
                text-decoration: underline
    .top-section-right
        p
            font-size: 18px
            line-height: 21px
            color: #3498DB
            &:hover
                text-decoration: underline
                cursor: pointer
        .center
            display: flex
            align-items: center
            justify-content: space-between
            span
                margin-left: 14px

.middle-section
    .check-list
        cursor: pointer
        margin: 20px 0
        background: #fff
        align-items: center
        height: 100px
        .el-checkbox__label
            display: none
        .auto-list_col
            height: 100px
            .auto-list_col_centered
                height: 100%
                display: grid
                align-items: center
        .check-list-time
            text-align: center
        .check-list-phone
            font-size: 16px
            line-height: 21px
        .check-list-autos
            font-size: 14px
            line-height: 21px
        .check-list-action
            img
                margin: 10px
            .single-p
                font-size: 18px
                text-align: center
                color: #dd6161
                &.is6
                    color: limegreen
        .check-list-person
            p
                margin: 5px
                font-size: 18px
                line-height: 22px
        .grey
            color: #98A9BC
        .doc-phone
            border: none
            font-size: 18px
            color: #98A9BC
            outline: none
            cursor: pointer

.bottom-section
    .pagination
        margin-bottom: 20px
        display: flex
        justify-content: flex-end
    .el-pagination .btn-next, .el-pagination .btn-prev
        background: transparent
    .el-dialog, .el-pager li
        background: transparent
    .bottom-section-action
        display: flex
        align-items: center
        justify-content: flex-end
        p
            font-size: 14px
            line-height: 17px
            text-transform: uppercase
            font-weight: bold
            margin: 0
        .el-button
            margin-left: 30px
            border: none
            border-radius: 0
            background: #E9E9E9
/*added new style*/
.middle-section.middle-section_driver
    .check-list
        .el-row
            height: 100%
        .check-list-person
            p
                margin: 0
        .check-list_phone, .check-list_date
            p
                font-size: 16px
                font-weight: normal
        .check-list_date
            p
                text-align: center
                line-height: 1
        .el-rate
            height: auto
        .auto-list_col
            height: auto
        .check-list-time
            padding-left: 25px
        .double_button
            margin-right: 35px
            .check-list-action
                display: flex
                p
                    margin: 0 5px
        .black_color
            color: #000000
        .red_color
            color: rgb(255, 0, 0)
.not_verified
    filter: invert(40%) grayscale(100%) brightness(55%) sepia(100%) hue-rotate(-50deg) saturate(400%) contrast(2);
.verify_bit
    margin-right: 30px
.not_approved
    visibility: hidden
.top-section_driver
    flex-direction: column
    .el-button--primary
        margin-bottom: 30px
</style>
